import { version } from '../../package.json';

// Runtime environment, read from Vite's import.meta.env (see app/.env*). This keeps
// the same typed shape the rest of the app consumes; only the source changed (from
// build-time file copying to Vite mode-based .env files). Booleans arrive as strings.
const toBool = (value: string | undefined) => value === 'true';

export const environment = {
  version,
  production: toBool(import.meta.env.VITE_PRODUCTION),
  protocol: import.meta.env.VITE_PROTOCOL,
  host_sk: import.meta.env.VITE_HOST_SK,
  host_cz: import.meta.env.VITE_HOST_CZ,
  basicAuthToken: import.meta.env.VITE_BASIC_AUTH_TOKEN,
  debug: toBool(import.meta.env.VITE_DEBUG),
  pdf_version_sk: import.meta.env.VITE_PDF_VERSION_SK,
  pdf_version_cz: import.meta.env.VITE_PDF_VERSION_CZ,
};
